import {twMerge} from "tailwind-merge";

export default function Textarea({label, id, requiredLabel = false, inputClasses = "", labelClasses = "", wordCount, ...otherProps}) {
    return (
        <div className="relative w-full">
            <label className={twMerge("block mr-[1.125rem] mb-2.5", labelClasses)} htmlFor={id}>
                {label}
                {requiredLabel ? <span className="text-pol-red align-super mr-0.5">*</span> : null}
            </label>
            <textarea id={id} className={twMerge("resize-none pol-simple-input text-pol-dark bg-pol-light-purple-12 border-pol-light-purple-11 hover:border-pol-blue focus:border-pol-blue", inputClasses)} {...otherProps}/>
            {
                wordCount ?
                    <span
                        className="absolute bottom-4 left-3.5 pointer-events-none text-pol-light-brown font-semibold text-xs">{otherProps.value ? otherProps.value.length : "0"}/{wordCount}</span>
                    : null
            }
        </div>
    )
}
